<script lang="ts">
	//UI
	//Utils
	//Types
	//Props
	export let right = false;
	export let fill = "#6591fa";
	export let stroke = "#6591fa";
	//Constants
	//Variables
	//Functions
	//Do

</script>

<svg
	class:right
	xmlns="http://www.w3.org/2000/svg"
	width="100%"
	height="100%"
	viewBox="0 0 41.208 41.61">
	<g>
		<g
			transform="translate(0 13.61)"
			style="stroke-width:1.5px;stroke:#6591fa;fill:none">
			<rect width="28" height="28" rx="2" style="stroke:none" />
			<rect
				x=".75"
				y=".75"
				width="26.5"
				height="26.5"
				rx="1.25"
				style="fill:none" />
		</g>
		<g>
			<g>
				<path
					d="M20.549 0a.473.473 0 0 0-.464.372 9.8 9.8 0 0 1-9.573 7.653A9.8 9.8 0 0 1 .939.372.474.474 0 0 0 .376.01.469.469 0 0 0 .01.566a10.75 10.75 0 0 0 10.5 8.4 10.749 10.749 0 0 0 10.5-8.4.474.474 0 0 0-.461-.566z"
					transform="rotate(-150 20.686 4.434)"
					fill={fill}
					stroke={stroke}
					style="stroke-width:.5px;" />
			</g>
			<g>
				<path
					d="M3.659 0a.47.47 0 0 0-.184.037L.285 1.4a.469.469 0 1 0 .368.862l2.76-1.178 1.178 2.76a.469.469 0 1 0 .862-.369L4.091.285A.469.469 0 0 0 3.659 0z"
					transform="rotate(-150 12.19 2.191)"
					fill={fill}
					stroke={stroke}
					style="stroke-width:.5px;" />
			</g>
		</g>
	</g>
</svg>

<style lang="scss">
	svg {
		&.right {
			transform: scaleX(-1);
		}
	}

</style>
